import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export interface OwnExpensePayoutInfoContext {
  isClassifiedReceipt: boolean;
  isOwnExpense: boolean;
  autoReceiptPayments?: boolean;
  hasReceiptApprover?: boolean;
  isManualPayment: boolean;
  submittedReceiptCount?: number;
  dismissed: boolean;
}

export type OwnExpensePayoutInfoVariant = "automaticPayout" | "pendingPayout";

export const OWN_EXPENSE_PAYOUT_INFO_MAX_SUBMITTED_RECEIPTS = 2;

const ReceiptHelper = {
  isRepresentation: (receiptCategory?: WintSuperkollAPIModel.ReceiptCategoryType) => {
    return (
      receiptCategory === WintSuperkollAPIModel.ReceiptCategoryType.Representation ||
      receiptCategory === WintSuperkollAPIModel.ReceiptCategoryType.EmployeeRepresentation
    );
  },
  // Both messages promise a payout to the user's bank account within days. A manually paid receipt never
  // gets one, and in a company with a receipt approver the receipt first waits for approval.
  // The company fields are undefined until the API sends them, and defaulting them either way would show
  // many companies the wrong message.
  getOwnExpensePayoutInfoVariant: ({
    isClassifiedReceipt,
    isOwnExpense,
    autoReceiptPayments,
    hasReceiptApprover,
    isManualPayment,
    submittedReceiptCount,
    dismissed,
  }: OwnExpensePayoutInfoContext): OwnExpensePayoutInfoVariant | null => {
    const show =
      !isClassifiedReceipt &&
      isOwnExpense &&
      !isManualPayment &&
      !dismissed &&
      autoReceiptPayments !== undefined &&
      hasReceiptApprover === false &&
      submittedReceiptCount !== undefined &&
      submittedReceiptCount < OWN_EXPENSE_PAYOUT_INFO_MAX_SUBMITTED_RECEIPTS;

    if (!show) {
      return null;
    }

    return autoReceiptPayments ? "automaticPayout" : "pendingPayout";
  },
};

export default ReceiptHelper;
